const url = "https://p.orocloud.io";

export { url };
